/**
 * Builds the society-context header used by public-search GraphQL requests.
 *
 * The GraphQL backends (`breedlogic-sb-graphql-api` and the underlying i6
 * service) only read `X-Society-Id` to scope requests to a society. The
 * registry / core backend reads `X-Organisation-Id`, but it is never reached
 * via Apollo — it's called from `createApiClients` which sets that header
 * separately from `SELECTED_ORG_ID` storage. Hence this helper only emits
 * `X-Society-Id`.
 *
 * Returns an empty object if `societyId` is null/undefined/empty so that
 * Apollo doesn't send `X-Society-Id: "undefined"` or `X-Society-Id: ""`
 * when the society context hasn't been resolved yet. Callers should still
 * use `skip: !orgId` on their queries, but this guard makes the helper
 * safe for callers that forget.
 */
export const setDefaultHeader = (
  societyId?: string | number | null,
): Record<string, string> => {
  if (societyId == null) return {};
  const value = String(societyId).trim();
  if (value === '') return {};
  return {
    'X-Society-Id': value,
  };
};
